import { Table, TableBox, TableContainer } from 'styles';

import { useClaimHook } from 'hooks/claim.hook';
import { useSelector } from 'react-redux';
import { RootState } from 'store/store';
import TableFooterBox from 'styles/box/TableFooterBox';
import LegendForServiceType from './LegendForServiceType.component';
import ClaimPaymentsBody from './components/ClaimPayments/ClaimPaymentsBody.component';
import ClaimPaymentsHeader from './components/ClaimPayments/ClaimPaymentsHeader.component';

const ClaimPaymentDetails = () => {
	const { claimData: claim, errorCode } = useSelector(
		(store: RootState) => store.claim,
	);

	const { showTaxColumns } = useClaimHook();

	const {
		amount: { components },
	} = claim;

	const rows = components;

	if (errorCode !== 0) {
		return null;
	}

	return (
		<TableBox>
			<TableContainer sx={{ pb: '5px' }}>
				<Table
					aria-label="customized table"
					sx={{
						minWidth: showTaxColumns ? { lg: '1846px', sm: '1562px' } : '100%',
					}}
				>
					<ClaimPaymentsHeader />
					<ClaimPaymentsBody payments={rows} />
				</Table>
			</TableContainer>
			<TableFooterBox>
				<LegendForServiceType />
			</TableFooterBox>
		</TableBox>
	);
};

export default ClaimPaymentDetails;
